import types from "../http_common";
import { apiRequest } from "../authConfig";

  // const contactsGetAll = uprn => {
  //   return types.json().get(`/Karma/Contacts/GetAll`);
  // };
  async function bearerToken(instance) {
    const account = instance.getActiveAccount()
    if (!account) {
      throw new Error(
        'No active account! Verify a user has been signed in and setActiveAccount has been called.'
      )
    }
    
    try {
      const response = await instance.acquireTokenSilent({
        ...apiRequest,
        account: account,
      })
      return response.accessToken;
    } catch (error) {
      // Token errors will be caught by the global axios interceptor
      // which will trigger the auth error modal
      console.error('[Token] Failed to acquire token:', error.message);
      throw error;
    }
  }

  const getSettings = async (instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get(`/Karma/getSettings`);
  }

  const getEnumSettings = async (instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get(`/Karma/getEnumSettings`);
  }

  const contactsGetAll = async (page,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get(`/Karma/Contacts/GetAll`);
  }

  const contactGet = async (id,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get(`/Karma/Contact/Get?id=`+id);
  }

  const contactUpdate = async (id,data,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.post(`/Karma/Contact/Update?id=`+id,data);
  }

  const contactsSearch = async (query,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get(`/Karma/Contacts/search?query=`+query);
  }

  const siteWideSearch = async (query,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get(`/Karma/siteWide/search?query=`+query);
  }

  const contactsFiltered = async (queries,page,limit,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.post(`/Karma/Contacts/GetAll?page=`+page+`&limit=`+limit,queries);   ///Karma/Contacts/filter?info=`+query);
  }

  const contactsFacets = async (payload, instance) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.post('/Karma/contacts/facets', payload);
  }

  const contactsGetNotes = async (id,page,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get(`/Karma/Contact/GetNotes?id=`+id+'&page='+page);
  }

  const exportReadableContactsExcel = async (instance, onDownloadProgress, options = {}) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.get('/Karma/contacts/exportReadable', {
      params: {
        maxRecords: options.maxRecords,
        queries: options.queries,
        contactIds: options.contactIds,
        projectOptionId: options.projectOptionId,
        includeContactStats: options.includeContactStats
      },
      responseType: 'blob',
      onDownloadProgress
    });
  }

  const exportReadableContactsStart = async (instance, options = {}) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.post('/Karma/contacts/exportReadable/start', {
      maxRecords: options.maxRecords,
      queries: options.queries,
      contactIds: options.contactIds,
      projectOptionId: options.projectOptionId,
      projectOptionIds: options.projectOptionIds,
      excludeStatusIds: options.excludeStatusIds,
      excludeStageIds: options.excludeStageIds,
      includeContactStats: options.includeContactStats
    });
  }

  const exportReadableContactsStatus = async (jobId, instance) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get(`/Karma/contacts/exportReadable/status?jobId=${jobId}`);
  }

  const exportQueueStatus = async (instance) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get('/Karma/export/queue/status');
  }

  const exportReadableContactsDownload = async (jobId, instance, onDownloadProgress) => {
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get(`/Karma/contacts/exportReadable/download?jobId=${jobId}`, {
      responseType: 'blob',
      onDownloadProgress
    });
  }

  const attachementGet = async (id,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    api.defaults.responseType = 'blob'
    return await api.get(`/Karma/Contact/GetAttachement?id=`+id);
  }

  const attachementUpload = async (formdata,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    api.defaults.headers["Content-Type"] = "multipart/form-data"
    return await api.post(`/Karma/Contact/UploadAttachement`,formdata);  //https://app.karmacrm.com/api/v2/attachments
  }


  const attachementUploadSync = async (formdata,instance,setUploadStarted,setProgress) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    api.defaults.headers["Content-Type"] = "multipart/form-data"
    return api.post('/Karma/Contact/UploadAttachement',
      formdata,{
      onUploadProgress: (progressEvent) => {
        setUploadStarted(true);
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress(percentCompleted);
      },
    });
    
  }
  

  const contactNotesUpdate = async (id,obj,instance,contractor =false) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.post(`/Karma/Contact/UpdateNotes?contractor=`+contractor+`&id=`+id,obj);
  }

  const sendSMS = async (number,message,instance) =>{
    var api = types.json();
    const item = await bearerToken(instance);
    api.defaults.headers.common.Authorization = 'Bearer ' + item;
    return await api.get(`/comms/sendSMS?number=`+number +` &message=`+message);
  }

  //http://localhost:8080/api/karma/contacts/getNotes?id=11737511&page=1

  //'https://happyengine.azurewebsites.net/api/Karma/Contacts/search?query=${query}';

  const KarmaApiService = {
    contactsGetAll,
    siteWideSearch,
    contactsSearch,
    contactGet,
    contactUpdate,
    contactNotesUpdate,
    attachementGet,
    attachementUpload,
    getSettings,
    getEnumSettings,
    contactsFiltered,
    contactsFacets,
    sendSMS,
    attachementUploadSync,
    contactsGetNotes,
    exportReadableContactsExcel,
    exportReadableContactsStart,
    exportReadableContactsStatus,
    exportReadableContactsDownload,
    exportQueueStatus
  };
  
  export default KarmaApiService;